import { render, staticRenderFns } from "./TablePagePerson.vue?vue&type=template&id=abf532f6"
import script from "./TablePagePerson.vue?vue&type=script&lang=js"
export * from "./TablePagePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports